export const heroSlides = [
  {
    id: 1,
    headline: 'Biometric Trust for the Digital World.',
    subtext: 'Ardeun delivers biometric identity, authentication, trusted communication, and anti-spoofing technologies for businesses, governments, and high-trust digital environments.',
    ctaPrimary: 'Explore Solutions',
    ctaSecondary: 'See bioMail & bioVerifier',
    badge: 'Identity. Verification. Security. Confidence.',
    bgImage: 'https://readdy.ai/api/search-image?query=Abstract%20biometric%20technology%20network%20visualization%20with%20soft%20blue%20gradient%20mesh%20and%20digital%20identity%20nodes%2C%20minimal%20clean%20corporate%20tech%20aesthetic%2C%20light%20airy%20background%20with%20subtle%20glowing%20connections%2C%20soft%20pastel%20cyan%20and%20white%20tones&width=1600&height=900&seq=hero-slide-1&orientation=landscape',
  },
  {
    id: 2,
    headline: 'Secure Identity. Verified Everywhere.',
    subtext: 'From enterprise email to cloud vaults, Ardeun biometric solutions protect every digital touchpoint with precision authentication and real-time spoof detection.',
    ctaPrimary: 'Explore Solutions',
    ctaSecondary: 'View Platform',
    badge: 'Enterprise-grade biometric security.',
    bgImage: 'https://readdy.ai/api/search-image?query=Digital%20security%20shield%20and%20fingerprint%20verification%20abstract%20visualization%2C%20soft%20cyan%20and%20white%20tones%2C%20modern%20minimal%20corporate%20tech%20art%2C%20clean%20light%20background%20with%20geometric%20patterns%2C%20subtle%20glow%20effects&width=1600&height=900&seq=hero-slide-2&orientation=landscape',
  },
  {
    id: 3,
    headline: 'Anti-Spoofing Built for Scale.',
    subtext: 'Deploy face anti-spoofing, biometric email verification, and secure access solutions that adapt to your infrastructure without compromising user experience.',
    ctaPrimary: 'Request a Demo',
    ctaSecondary: 'Documentation',
    badge: 'Liveness detection at the edge.',
    bgImage: 'https://readdy.ai/api/search-image?query=Anti-spoofing%20facial%20recognition%20technology%20abstract%20art%2C%20soft%20blue%20and%20mint%20gradient%2C%20minimal%20modern%20corporate%20design%2C%20light%20airy%20atmosphere%20with%20subtle%20tech%20elements%2C%20digital%20mesh%20and%20scanning%20lines&width=1600&height=900&seq=hero-slide-3&orientation=landscape',
  },
];

export const ecosystemProducts = [
  {
    id: 'biomail',
    name: 'bioMail + bioVerifier',
    tagline: 'Trusted email. Verified senders. Encrypted Secure P2P communication.',
    icon: 'ri-mail-check-line',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    id: 'qboverifier',
    name: 'QBOVerifier',
    tagline: 'QuickBooks verified sender invoices and documents protecting against BEC and BIF fraud.',
    icon: 'ri-file-check-line',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    id: 'xeroverifier',
    name: 'XeroVerifier',
    tagline: 'Xero verified sender invoices and documents protecting against BEC and BIF fraud.',
    icon: 'ri-file-text-line',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    id: 'biovault',
    name: 'bioVault',
    tagline: 'Secure virtual encrypted drives using personal biometric login to ensure private access and hidden encrypted data',
    icon: 'ri-database-2-line',
    color: 'bg-primary-100 text-primary-700',
  },
  {
    id: 'biodesktop',
    name: 'bioDesktop',
    tagline: 'Windows Hello login alternative with support for multiple biometric devices.',
    icon: 'ri-lock-line',
    color: 'bg-accent-100 text-accent-700',
  },
  {
    id: 'biopass',
    name: 'bioPass Wallet',
    tagline: 'Biometric Password Wallet for secure web site access.',
    icon: 'ri-wallet-line',
    color: 'bg-secondary-100 text-secondary-700',
  },
  {
    id: 'antispoof',
    name: 'Face AntiSpoof API',
    tagline: 'Face anti-spoofing and liveness technology via API access.',
    icon: 'ri-fingerprint-line',
    color: 'bg-primary-100 text-primary-700',
  },
];

// Products temporarily hidden from the site cards. Remove an id here to show it again.
export const hiddenProductIds = ['biodesktop', 'biopass'];

export const featureHighlights = [
  {
    id: 1,
    title: 'Verify Identity',
    description: 'Confirm the right person every time.',
    icon: 'ri-shield-user-line',
  },
  {
    id: 2,
    title: 'Protect Communication',
    description: 'Secure messages and stop phishing.',
    icon: 'ri-mail-lock-line',
  },
  {
    id: 3,
    title: 'Secure Access',
    description: 'Enable seamless, biometric access across systems.',
    icon: 'ri-lock-unlock-line',
  },
  {
    id: 4,
    title: 'Stop Spoofing & Fraud',
    description: 'Detect and block imposters and synthetic attacks.',
    icon: 'ri-eye-off-line',
  },
];

export const solutionProducts = [
  {
    id: 'biomail',
    name: 'bioMail + bioVerifier',
    shortDesc: 'Biometric encrypted email, sender verification, anti-phishing.',
    fullDesc: 'End-to-end biometric email security that verifies every sender, encrypts content, and eliminates phishing at the source. Integrates with existing mail infrastructure.',
    icon: 'ri-mail-check-line',
    iconBg: 'bg-primary-500',
  },
  {
    id: 'qboverifier',
    name: 'QBOVerifier',
    shortDesc: 'Verified invoice and payment for QuickBooks workflows.',
    fullDesc: 'Automated invoice and payment verification for QuickBooks. Ensures every transaction is authenticated with biometric proof before processing.',
    icon: 'ri-file-check-line',
    iconBg: 'bg-accent-500',
  },
  {
    id: 'xeroverifier',
    name: 'XeroVerifier',
    shortDesc: 'Verified invoice and payment for Xero workflows.',
    fullDesc: 'Seamless biometric verification layer for Xero accounting workflows. Protects invoice approvals and payment authorizations with identity certainty.',
    icon: 'ri-file-text-line',
    iconBg: 'bg-secondary-500',
  },
  {
    id: 'biovault',
    name: 'bioVault',
    shortDesc: 'Secure virtual drives with biometric and encrypted access.',
    fullDesc: 'Cloud-native secure storage with biometric-only access. Encrypted virtual drives that unlock with fingerprint, face, or voice recognition.',
    icon: 'ri-database-2-line',
    iconBg: 'bg-primary-500',
  },
  {
    id: 'biodesktop',
    name: 'bioDesktop',
    shortDesc: 'Windows login alternative with biometric device support.',
    fullDesc: 'Replace passwords on Windows workstations with multi-factor biometric authentication. Supports fingerprint readers, webcams, and external biometric devices.',
    icon: 'ri-lock-line',
    iconBg: 'bg-accent-500',
  },
  {
    id: 'biopass',
    name: 'bioPass Wallet',
    shortDesc: 'Biometric website and password access wallet.',
    fullDesc: 'A secure biometric password manager and web access wallet. Log into any site with a single biometric gesture instead of typing passwords.',
    icon: 'ri-wallet-line',
    iconBg: 'bg-secondary-500',
  },
  {
    id: 'antispoof',
    name: 'Face AntiSpoof API',
    shortDesc: 'Face anti-spoofing and liveness technology via API.',
    fullDesc: 'Developer-friendly API for face liveness detection and anti-spoofing. Prevents photo, video, mask, and deepfake attacks with 99.7% accuracy.',
    icon: 'ri-fingerprint-line',
    iconBg: 'bg-primary-500',
  },
];

export const industries = [
  {
    id: 'finance',
    name: 'Finance & Payments',
    description: 'Strengthen trust in transactions, reduce fraud and ensure regulatory compliance.',
    icon: 'ri-bank-card-line',
  },
  {
    id: 'enterprise',
    name: 'Enterprise & Corporate',
    description: 'Secure communication, protect data and streamline employee access.',
    icon: 'ri-building-4-line',
  },
  {
    id: 'government',
    name: 'Government',
    description: 'Enable secure digital services, protect citizen identity and defend critical systems.',
    icon: 'ri-building-2-line',
  },
  {
    id: 'healthcare',
    name: 'Healthcare & Legal',
    description: 'Protect sensitive information and ensure privacy with strong biometric verification.',
    icon: 'ri-hospital-line',
  },
];

export const howItWorksSteps = [
  {
    id: 1,
    number: '01',
    title: 'Capture Identity',
    description: 'Capture biometric data and verify liveness to establish a unique, trusted identity.',
    icon: 'ri-fingerprint-line',
  },
  {
    id: 2,
    number: '02',
    title: 'Authenticate',
    description: 'Authenticate the user securely across devices and applications using biometric verification.',
    icon: 'ri-shield-check-line',
  },
  {
    id: 3,
    number: '03',
    title: 'Protect the Interaction',
    description: 'Encrypt communications and secure every interaction with end-to-end protection.',
    icon: 'ri-shield-keyhole-line',
  },
  {
    id: 4,
    number: '04',
    title: 'Verify and Trust',
    description: 'Continuously verify identity and context to ensure trusted access and decision-making.',
    icon: 'ri-checkbox-circle-line',
  },
];

export const whyChooseFeatures = [
  {
    id: 1,
    title: 'Biometric-first architecture',
    description: 'Purpose-built for strong, reliable biometric trust from the ground up.',
    icon: 'ri-fingerprint-line',
  },
  {
    id: 2,
    title: 'Cross-platform ecosystem',
    description: 'Seamless solutions across devices, cloud and on-premise environments.',
    icon: 'ri-apps-line',
  },
  {
    id: 3,
    title: 'Fraud and impersonation defense',
    description: 'Advanced anti-spoofing and fraud detection at every layer.',
    icon: 'ri-shield-check-line',
  },
  {
    id: 4,
    title: 'Enterprise API integration',
    description: 'Flexible APIs to embed trust into any workflow or application.',
    icon: 'ri-code-box-line',
  },
  {
    id: 5,
    title: 'Secure user experience',
    description: 'Frictionless, fast and intuitive biometric experiences.',
    icon: 'ri-emotion-happy-line',
  },
  {
    id: 6,
    title: 'Modern trust infrastructure',
    description: 'Scalable, reliable and built for the future of digital trust.',
    icon: 'ri-stack-line',
  },
];

export const navLinks = [
  {
    label: 'Solutions',
    href: '#solutions',
    children: [
      { label: 'Biometric Email Security', href: '#' },
      { label: 'Identity Verification', href: '#' },
      { label: 'Secure Access', href: '#' },
      { label: 'Anti-Spoofing', href: '#' },
    ],
  },
  {
    label: 'Products',
    href: '#products',
    children: [
      { label: 'bioMail + bioVerifier', href: '#' },
      { label: 'QBOVerifier', href: '#' },
      { label: 'XeroVerifier', href: '#' },
      { label: 'bioVault', href: '#' },
      { label: 'bioDesktop', href: '#' },
      { label: 'bioPass Wallet', href: '#' },
      { label: 'Face AntiSpoof API', href: '#' },
    ],
  },
  {
    label: 'Platform',
    href: '#platform',
    children: [
      { label: 'Architecture Overview', href: '#' },
      { label: 'API Documentation', href: '#' },
      { label: 'Integrations', href: '#' },
      { label: 'Security', href: '#' },
    ],
  },
  {
    label: 'Industries',
    href: '#industries',
    children: [
      { label: 'Finance & Payments', href: '#' },
      { label: 'Enterprise', href: '#' },
      { label: 'Government', href: '#' },
      { label: 'Healthcare', href: '#' },
    ],
  },
  {
    label: 'Trust',
    href: '#trust',
    children: [
      { label: 'Compliance', href: '#' },
      { label: 'Certifications', href: '#' },
      { label: 'Privacy', href: '#' },
      { label: 'Security Whitepaper', href: '#' },
    ],
  },
  {
    label: 'Playground',
    href: '/playground',
  },
];

export const footerColumns = [
  {
    title: 'Products',
    links: [
      { label: 'bioMail + bioVerifier', href: '#' },
      { label: 'QBOVerifier', href: '#' },
      { label: 'XeroVerifier', href: '#' },
      { label: 'bioVault', href: '#' },
      { label: 'bioDesktop', href: '#' },
      { label: 'bioPass Wallet', href: '#' },
      { label: 'Face AntiSpoof API', href: '#' },
    ],
  },
  {
    title: 'Solutions',
    links: [
      { label: 'Biometric Email Security', href: '#' },
      { label: 'Identity Verification', href: '#' },
      { label: 'Secure Access', href: '#' },
      { label: 'Anti-Spoofing', href: '#' },
      { label: 'API & Integrations', href: '#' },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'About Ardeun', href: '#' },
      { label: 'Leadership', href: '#' },
      { label: 'News & Press', href: '#' },
      { label: 'Careers', href: '#' },
      { label: 'Partners', href: '#' },
      { label: 'Contact', href: '#contact' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Documentation', href: '#' },
      { label: 'White Papers', href: '#' },
      { label: 'Case Studies', href: '#' },
      { label: 'Blog', href: '#' },
      { label: 'Support', href: '#' },
    ],
  },
];